__turbopack_context__.v({
  "className": "anton_64e73319-module__Gd7UAG__className",
  "variable": "anton_64e73319-module__Gd7UAG__variable",
});
